export default {
    username: 'Username',
    email: 'Email',
    password: 'Password',
    confirmPassword: 'Confirm Password',
    privacyPolicy: 'Privacy Policy',
    terms: 'Terms & Conditions',
    consent: 'I am over 18 years old. I have read the ',
    createAccount: 'Create Account',
    thankYouForSigningUp: 'Thank you for signing up!',
    thankYouForVerifying: 'Thank you for verifying!',
    refresh: 'Refresh',
    refreshToContinue: 'Please refresh this page to continue.',
    sentEmail: 'We have sent a verification email to ',
    openEmailClickLink:
        'Please open the email and click on the verification link to continue.',
    checkSpam:
        'Note: Make sure to check your Spam/Junk folder for our message. If it showed up there, please click "Not Spam" and/or "Enable Links" to make the confirmation work.',
    awaitingVerification: 'Awaiting your email verification...',
    ifVerifiedButMessagePersists:
        'If you have already verified and this message persists, please refresh this page.',
}
